module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In bringing this book to life, countless individuals’ unwavering support and encouragement have been my guiding light. To my beloved children, Joseph, Jessica, Valerie, Kenneth, Gaspare and Melissa, who have stood by my side through every triumph and challenge, your love and encouragement have been my source of strength. To my beloved nieces and Joe Emerick, who always provide me with a great writing getaway, and to my cherished friends, you know who you are. You have all been with me through thick and thin, always offering a listening ear and a helping hand. I am endlessly grateful for your unwavering support. A special thank-you to my new friend Olga Topchii, photographer extraordinaire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A special acknowledgment goes to Patricia Salmon, a remarkable historian whose passion for the history, beauty and lore of Staten Island ignited my curiosity and inspired me to delve deeper into the fascinating history of the borough. Your advice, presentations and books have been instrumental in shaping this book, and I am profoundly grateful for your invaluable contributions. Thank you to The History Press and my editors, who believed in this project.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To all who have contributed, big or small, to the creation of this book, I offer my sincerest thanks. Your support and encouragement have not only made this journey possible but also enriched it with your unique perspectives and insights. Your generosity truly humbles me, and I am deeply grateful for your contributions.")]), _vm._v(" "), _c('div', {
    staticClass: "image-break"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/14.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A map of Staten Island, originally Richmond County. "), _c('i', [_vm._v("NYPL Digital Collection")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-795b0ea0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgements.vue
// module id = 72
// module chunks = 0